import React,{useEffect, useState} from 'react';
import AmbassadorHeader from '../../components/common/AmbassadorHeader';
import Logo from '../../components/common/Logo';
import SidebarMenu from '../../components/ambassador/SidebarMenu';
import { Link, useNavigate,useLocation } from "react-router-dom";
import StudentTable from '../../components/ambassador/StudentTable';
import { getAmbassadorDetail,getOnBoardStudentList } from '../../actions/AmbassadorActions';
import InMobileSideMenu from '../../components/ambassador/InMobileSideMenu';
import { countryId } from '../../config/Constant';

 const AmbassadorDashobard=(props)=>{
   const navigate = useNavigate();
   const [profileDetail, setProfileDetail] = useState({});
   const [miniSidebar,setMiniSidebar] = useState(!true);
   const [onboardList,setOnboardList] = useState([]);
   const [studentType,setStudentType] = useState();
   const [freeList,setFreeList] = useState([]);
   const [paidList,setPaidList] = useState([]);
   const [unPaidList,setUnpaidList] = useState([]);
   const [freeCount,setFreeCount] = useState(undefined);
   const [paidCount,setPaidCount] = useState(undefined);
   const [unpaidCount,setUnpaidCount] = useState(undefined);

   
   useEffect(async() => {
      sessionStorage.getItem("ambDetail")
      ? navigate("/ambassador/dashboard")
      : navigate("/ambassador/login");

      await getAmbassadorDetail()
      .then((res) => {
         setProfileDetail(res.data)
      })

      await getOnBoardStudentList()
      .then((res) => {
         setOnboardList(res.data.list)
         setFreeCount(res.data.free)
         setPaidCount(res.data.paid)
         setUnpaidCount(res.data.unpaid)

      })

   },[])
   
// console.log('onboard student list',onboardList)
   
const getFreeStudentList=()=>{

   let list=onboardList.filter(item=>item.is_free==1)
   setFreeList(list)
}

const getPaidStudentList=()=>{

   let list=onboardList.filter(item=>item.is_free==0 && item.is_paid==1)
   setPaidList(list)
}

const setMiniSide = (val) => {
   setMiniSidebar(val)
}

const getUnpaidaidStudentList=()=>{
   let list=onboardList.filter(item=>item.is_free==0 && item.is_paid==0)
   setUnpaidList(list)
}



    return (
    <>
      <div className='mainAmb_wrapper'>
      {/* Sidebar */}
      <div className={`sidebar_contain`}>
       
            <Logo alt="Logo"/>
            <div className='sidebar_menu_contains'>
               <SidebarMenu detail={profileDetail}/>
            </div>
         
      </div>

      <div className='mobile_sideMenuWrap d-block d-lg-none'>
         <InMobileSideMenu detail={profileDetail}/>
      </div>
      
      <div className='main_contentAmb'>
      {/* Header */}
      <div className='headerAmb_contain'>
      <AmbassadorHeader miniSidebar={setMiniSide} detail={profileDetail}/>
      </div>
      <div className='amb_content mt-4'>
         <div className='container'>
            <div className='row gx-2 gx-md-3'>
               <div className='col-6 col-md-4 col-lg-3'>
                  <div className='amb_dash_widget mt-2 bg_warning'>
                     <h3>Total Students</h3>
                     {onboardList!==undefined && onboardList.length>0 ?<h4>{onboardList.length}</h4> : <h4>0</h4>}
                  </div>
               </div>
               <div className='col-6 col-md-4 col-lg-3'>
                  <div className='amb_dash_widget mt-2 bg_success '>
                     <h3>Free Students</h3>
                     {freeCount!==undefined?<h4>{freeCount}</h4>: <h4>0</h4>}
                  </div>
               </div>
               <div className='col-6 col-md-4 col-lg-3'>
                  <div className='amb_dash_widget mt-2 bg_darkWarning'>
                     <h3>Paid Students</h3>
                    {paidCount!==undefined? <h4>{paidCount}</h4>: <h4>0</h4>}
                  </div>
               </div>
               <div className='col-6 col-md-4 col-lg-3'>
                  <div className='amb_dash_widget mt-2 bg_danger'>
                     <h3>Unpaid Students</h3>
                    {unpaidCount!==undefined? <h4>{unpaidCount}</h4>: <h4>0</h4>}
                  </div>
               </div>
            </div>

            <div className='row mt-5'>
               <div className='col-lg-12'>
                  <div className='dash_card card mb-5 shadow-sm'>
                     <div className='card-header'>
                     <ul className="nav nav-tabs card-header-tabs">
                        <li className="nav-item">
                        <button className="nav-link active"  id="all-tab" data-bs-toggle="tab" data-bs-target="#all-students" type="button" role="tab" aria-selected="true" >All</button>
                        </li>
                        <li className="nav-item">
                        <button className="nav-link " id="free-tab" data-bs-toggle="tab" data-bs-target="#free-students" type="button" role="tab" aria-selected="false" onClick={getFreeStudentList}>Free</button>
                        </li>
                        <li className="nav-item">
                        <button className="nav-link" id="paid-tab" data-bs-toggle="tab" data-bs-target="#paid-students" type="button" role="tab" aria-selected="false" onClick={getPaidStudentList}>Paid</button>
                        </li>
                        <li className="nav-item">
                        <button className="nav-link" id="unpaid-tab" data-bs-toggle="tab" data-bs-target="#unpaid-students" type="button" role="tab" aria-selected="false" onClick={getUnpaidaidStudentList}>Unpaid</button>
                        </li>

                     </ul>
                     
                     {profileDetail !== undefined && profileDetail.country_id == countryId.UAE ?
                      <div  className="card-tools">
                      <Link className='btn btn-primary btn-md ms-3' to="/ambassador/add-new-student">Add New</Link>
                      </div>
                      :''
                  }
                    

                      {/* <div  className="card-tools">
                      <Link className='btn btn-primary btn-md ms-3' to="/ambassador/add-new-student">Add New</Link>
                      </div> */}
                      
               
                    
                     </div>
                     <div className='card-body'>
                        <div className='row'>
                        <div className='col-lg-12'>
                        <div  className="tab-content" id="myTabContent">
                           <div  className="tab-pane fade show active" id="all-students" role="tabpanel" aria-labelledby="all-tab" tabindex="0">
                              <StudentTable detail={profileDetail} studentData={onboardList}/>
                           </div>
                           <div  className="tab-pane fade" id="free-students" role="tabpanel" aria-labelledby="free-tab" tabindex="0">
                              <StudentTable detail={profileDetail} studentData={freeList}/>
                           </div>
                           <div  className="tab-pane fade" id="paid-students" role="tabpanel" aria-labelledby="paid-tab" tabindex="0">
                              <StudentTable detail={profileDetail} studentData={paidList}/>
                           </div>

                           <div  className="tab-pane fade" id="unpaid-students" role="tabpanel" aria-labelledby="unpaid-tab" tabindex="0">
                              <StudentTable detail={profileDetail} studentData={unPaidList}/>
                           </div>
                        </div>
                        </div>
                        </div>
                        
                
                     </div>
                  </div>
               </div>
            </div>
         </div>
      
      </div>
      
      </div>


      </div>
      
    
    
    </>)
 }

 export default AmbassadorDashobard